import { render } from "./Visitors.vue?vue&type=template&id=1e3995be&scoped=true"
import script from "./Visitors.vue?vue&type=script&lang=js"
export * from "./Visitors.vue?vue&type=script&lang=js"

import "./Visitors.vue?vue&type=style&index=0&id=1e3995be&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3995be"]])

export default __exports__